var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"el",attrs:{"src":_vm.src,"alt":_vm.alt},on:{"click":function($event){return _vm.handleClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }